import { Provider } from "@angular/core";
import { NotificacionServiceEmisor, NotificacionService, NotificacionServiceReceptor } from "./notificacion.service";

export const notificacionProviders: Provider[] = [
    { provide: NotificacionServiceEmisor, useExisting: NotificacionService },
    { provide: NotificacionServiceReceptor, useExisting: NotificacionService }
];
